<template>
  <main>
    <trac-loading v-if="isLoading"></trac-loading>
    <trac-back-button :backAction="backAction">
      KYC Menu
    </trac-back-button>
    <div class="mt-2 text-sm font-medium">
      Complete KYC by verifying the following.
    </div>
    <form
      class="
        flex
        mb-10
        lg:mb-0
        justify-center
        flex-col
        bg-white
        rounded-md
        mt-12
        big-shadow
        p-5
        mr-4
        lg:mr-0
        items-center
      "
    >
      <h1 class="mt-10 text-primaryBlue font-medium">Take a Selfie</h1>

      <div>
        <p class="text-center tracking-normal mt-4 lg:text-sm text-xs lg:w-96">
          Take a clear photo of your face. We need this
          <br class="hidden lg:block" />
          to verify your identity. You can always change this photo later.
        </p>

        <div class="mb-10 flex justify-center items-center mt-12">
          <svg
            class="cursor-pointer"
            v-if="!picture"
            @click.prevent="cameraModal = true"
            width="130"
            height="130"
            viewBox="0 0 130 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="130" height="130" rx="65" fill="#FAFAFA" />
            <path
              d="M78.5829 44.6776H71.2961L70.629 42.813L69.7357 40.3086H59.964L59.0707 42.813L58.4036 44.6776H51.1207C50.949 44.6776 50.8086 44.818 50.8086 44.9897V62.7777C50.8086 62.9494 50.949 63.0898 51.1207 63.0898H78.5829C78.7546 63.0898 78.895 62.9494 78.895 62.7777V44.9897C78.895 44.818 78.7546 44.6776 78.5829 44.6776ZM64.8518 59.657C61.4034 59.657 58.6104 56.864 58.6104 53.4156C58.6104 49.9672 61.4034 47.1742 64.8518 47.1742C68.3002 47.1742 71.0932 49.9672 71.0932 53.4156C71.0932 56.864 68.3002 59.657 64.8518 59.657Z"
              fill="#B2E7FF"
            />
            <path
              d="M64.8508 47.1758C61.4024 47.1758 58.6094 49.9688 58.6094 53.4172C58.6094 56.8656 61.4024 59.6586 64.8508 59.6586C68.2992 59.6586 71.0922 56.8656 71.0922 53.4172C71.0922 49.9688 68.2992 47.1758 64.8508 47.1758ZM64.8508 57.1621C62.7833 57.1621 61.1059 55.4847 61.1059 53.4172C61.1059 51.3497 62.7833 49.6724 64.8508 49.6724C66.9183 49.6724 68.5957 51.3497 68.5957 53.4172C68.5957 55.4847 66.9183 57.1621 64.8508 57.1621Z"
              fill="#06B6CB"
            />
            <path
              d="M78.583 41.869H73.2778L72.0139 38.327C71.9266 38.0846 71.7666 37.8751 71.5557 37.7271C71.3448 37.5791 71.0934 37.4998 70.8358 37.5H58.8679C58.3413 37.5 57.8693 37.8316 57.6937 38.327L56.4259 41.869H51.1207C49.3965 41.869 48 43.2655 48 44.9897V62.7778C48 64.502 49.3965 65.8985 51.1207 65.8985H78.583C80.3072 65.8985 81.7037 64.502 81.7037 62.7778V44.9897C81.7037 43.2655 80.3072 41.869 78.583 41.869ZM78.8951 62.7778C78.8951 62.9494 78.7546 63.0898 78.583 63.0898H51.1207C50.9491 63.0898 50.8086 62.9494 50.8086 62.7778V44.9897C50.8086 44.8181 50.9491 44.6776 51.1207 44.6776H58.4037L59.0707 42.813L59.964 40.3086H69.7358L70.6291 42.813L71.2961 44.6776H78.583C78.7546 44.6776 78.8951 44.8181 78.8951 44.9897V62.7778Z"
              fill="white"
            />
            <path
              d="M29.736 83.684H27.048V82.1H34.368V83.684H31.68V90.5H29.736V83.684ZM38.1828 83.948C39.1828 83.948 39.9508 84.188 40.4868 84.668C41.0228 85.14 41.2908 85.856 41.2908 86.816V90.5H39.5388V89.696C39.1868 90.296 38.5308 90.596 37.5708 90.596C37.0748 90.596 36.6428 90.512 36.2748 90.344C35.9148 90.176 35.6388 89.944 35.4468 89.648C35.2548 89.352 35.1588 89.016 35.1588 88.64C35.1588 88.04 35.3828 87.568 35.8308 87.224C36.2868 86.88 36.9868 86.708 37.9308 86.708H39.4188C39.4188 86.3 39.2948 85.988 39.0468 85.772C38.7988 85.548 38.4268 85.436 37.9308 85.436C37.5868 85.436 37.2468 85.492 36.9108 85.604C36.5828 85.708 36.3028 85.852 36.0708 86.036L35.3988 84.728C35.7508 84.48 36.1708 84.288 36.6588 84.152C37.1548 84.016 37.6628 83.948 38.1828 83.948ZM38.0388 89.336C38.3588 89.336 38.6428 89.264 38.8908 89.12C39.1388 88.968 39.3148 88.748 39.4188 88.46V87.8H38.1348C37.3668 87.8 36.9828 88.052 36.9828 88.556C36.9828 88.796 37.0748 88.988 37.2588 89.132C37.4508 89.268 37.7108 89.336 38.0388 89.336ZM46.3821 87.968L45.4821 88.856V90.5H43.6101V81.596H45.4821V86.636L48.2181 84.044H50.4501L47.7621 86.78L50.6901 90.5H48.4221L46.3821 87.968ZM58.1997 87.296C58.1997 87.32 58.1877 87.488 58.1637 87.8H53.2797C53.3677 88.2 53.5757 88.516 53.9037 88.748C54.2317 88.98 54.6397 89.096 55.1277 89.096C55.4637 89.096 55.7597 89.048 56.0157 88.952C56.2797 88.848 56.5237 88.688 56.7477 88.472L57.7437 89.552C57.1357 90.248 56.2477 90.596 55.0797 90.596C54.3517 90.596 53.7077 90.456 53.1477 90.176C52.5877 89.888 52.1557 89.492 51.8517 88.988C51.5477 88.484 51.3957 87.912 51.3957 87.272C51.3957 86.64 51.5437 86.072 51.8397 85.568C52.1437 85.056 52.5557 84.66 53.0757 84.38C53.6037 84.092 54.1917 83.948 54.8397 83.948C55.4717 83.948 56.0437 84.084 56.5557 84.356C57.0677 84.628 57.4677 85.02 57.7557 85.532C58.0517 86.036 58.1997 86.624 58.1997 87.296ZM54.8517 85.364C54.4277 85.364 54.0717 85.484 53.7837 85.724C53.4957 85.964 53.3197 86.292 53.2557 86.708H56.4357C56.3717 86.3 56.1957 85.976 55.9077 85.736C55.6197 85.488 55.2677 85.364 54.8517 85.364ZM67.8625 82.1C68.6065 82.1 69.2505 82.224 69.7945 82.472C70.3465 82.72 70.7705 83.072 71.0665 83.528C71.3625 83.984 71.5105 84.524 71.5105 85.148C71.5105 85.764 71.3625 86.304 71.0665 86.768C70.7705 87.224 70.3465 87.576 69.7945 87.824C69.2505 88.064 68.6065 88.184 67.8625 88.184H66.1705V90.5H64.2265V82.1H67.8625ZM67.7545 86.6C68.3385 86.6 68.7825 86.476 69.0865 86.228C69.3905 85.972 69.5425 85.612 69.5425 85.148C69.5425 84.676 69.3905 84.316 69.0865 84.068C68.7825 83.812 68.3385 83.684 67.7545 83.684H66.1705V86.6H67.7545ZM77.4325 83.948C78.2325 83.948 78.8765 84.188 79.3645 84.668C79.8605 85.148 80.1085 85.86 80.1085 86.804V90.5H78.2365V87.092C78.2365 86.58 78.1245 86.2 77.9005 85.952C77.6765 85.696 77.3525 85.568 76.9285 85.568C76.4565 85.568 76.0805 85.716 75.8005 86.012C75.5205 86.3 75.3805 86.732 75.3805 87.308V90.5H73.5085V81.596H75.3805V84.716C75.6285 84.468 75.9285 84.28 76.2805 84.152C76.6325 84.016 77.0165 83.948 77.4325 83.948ZM85.5727 90.596C84.8927 90.596 84.2807 90.456 83.7367 90.176C83.2007 89.888 82.7807 89.492 82.4767 88.988C82.1727 88.484 82.0207 87.912 82.0207 87.272C82.0207 86.632 82.1727 86.06 82.4767 85.556C82.7807 85.052 83.2007 84.66 83.7367 84.38C84.2807 84.092 84.8927 83.948 85.5727 83.948C86.2527 83.948 86.8607 84.092 87.3967 84.38C87.9327 84.66 88.3527 85.052 88.6567 85.556C88.9607 86.06 89.1127 86.632 89.1127 87.272C89.1127 87.912 88.9607 88.484 88.6567 88.988C88.3527 89.492 87.9327 89.888 87.3967 90.176C86.8607 90.456 86.2527 90.596 85.5727 90.596ZM85.5727 89.06C86.0527 89.06 86.4447 88.9 86.7487 88.58C87.0607 88.252 87.2167 87.816 87.2167 87.272C87.2167 86.728 87.0607 86.296 86.7487 85.976C86.4447 85.648 86.0527 85.484 85.5727 85.484C85.0927 85.484 84.6967 85.648 84.3847 85.976C84.0727 86.296 83.9167 86.728 83.9167 87.272C83.9167 87.816 84.0727 88.252 84.3847 88.58C84.6967 88.9 85.0927 89.06 85.5727 89.06ZM95.153 90.188C94.969 90.324 94.741 90.428 94.469 90.5C94.205 90.564 93.925 90.596 93.629 90.596C92.861 90.596 92.265 90.4 91.841 90.008C91.425 89.616 91.217 89.04 91.217 88.28V85.628H90.221V84.188H91.217V82.616H93.089V84.188H94.697V85.628H93.089V88.256C93.089 88.528 93.157 88.74 93.293 88.892C93.437 89.036 93.637 89.108 93.893 89.108C94.189 89.108 94.441 89.028 94.649 88.868L95.153 90.188ZM99.7016 90.596C99.0216 90.596 98.4096 90.456 97.8656 90.176C97.3296 89.888 96.9096 89.492 96.6056 88.988C96.3016 88.484 96.1496 87.912 96.1496 87.272C96.1496 86.632 96.3016 86.06 96.6056 85.556C96.9096 85.052 97.3296 84.66 97.8656 84.38C98.4096 84.092 99.0216 83.948 99.7016 83.948C100.382 83.948 100.99 84.092 101.526 84.38C102.062 84.66 102.482 85.052 102.786 85.556C103.09 86.06 103.242 86.632 103.242 87.272C103.242 87.912 103.09 88.484 102.786 88.988C102.482 89.492 102.062 89.888 101.526 90.176C100.99 90.456 100.382 90.596 99.7016 90.596ZM99.7016 89.06C100.182 89.06 100.574 88.9 100.878 88.58C101.19 88.252 101.346 87.816 101.346 87.272C101.346 86.728 101.19 86.296 100.878 85.976C100.574 85.648 100.182 85.484 99.7016 85.484C99.2216 85.484 98.8256 85.648 98.5136 85.976C98.2016 86.296 98.0456 86.728 98.0456 87.272C98.0456 87.816 98.2016 88.252 98.5136 88.58C98.8256 88.9 99.2216 89.06 99.7016 89.06Z"
              fill="#003282"
            />
          </svg>
          <img
            v-else
            :src="pictureInBase64"
            class="w-32 h-32 rounded-full object-cover"
            alt=""
          />
          <!-- <div class="w-32 h-32 rounded-full object-cover" v-else-if="loading">
            <svg class="spinner ml-4" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div> -->
        </div>

        <div v-if="picture" class="mt-8 flex items-center w-full mb-6">
          <trac-button
            :danger="true"
            @click.native="picture = null"
            class="w-full"
            ><span class="px-12 text-center">Delete</span></trac-button
          >
          <trac-button @click.native="toNext" class="w-full ml-4"
            ><span class="px-12 text-center">Continue</span></trac-button
          >
        </div>
      </div>
    </form>
    <div v-if="cameraModal">
      <div v-if="check">
        <v-easy-camera
          ref="camera"
          v-model="picture"
          @approve="approveImage"
          @close="closeCarmera"
          output="blob"
          :mustApprove="true"
          :fullscreen="true"
          :fullscreenZIndex="99999999999"
        ></v-easy-camera>
      </div>
      <div v-else class="flex flex-col items-center">
        <svg
          width="89"
          height="88"
          class="mt-10"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="44.9961"
            cy="44"
            r="42"
            stroke="#CE1112"
            stroke-width="4"
          />
          <path
            d="M64.9961 24L24.9961 64"
            stroke="#CE1112"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.9961 24L64.9961 64"
            stroke="#CE1112"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <p class="py-10 text-center tracking-normal">
          This device doesnt have any camera connected
        </p>
      </div>
    </div>
  </main>
</template>

<script>
import {
  GET_USER_BUSINESS_ID,
  GET_USER_BUSINESS_DATA,
} from "../../browser-db-config/localStorage";
import { eventBus } from "./../../main";
import EasyCamera from "easy-vue-camera";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      firstAttempt: 0,
      loading: false,
      cameraModal: false,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      isCustomKycRoute: false,
      stream: undefined,
      link: "#",
      check: true,
      picture: null,
      pictureInBase64: null,
      payload: {
        reference: "",
        verificationType: "EMAIL",
        businessId: "",
      },
    };
  },
  components: {
    "v-easy-camera": EasyCamera,
  },
  computed: {
    ...mapGetters(["GET_KYC_PIC"]),
  },
  watch: {
    cameraModal(x) {
      this.$nextTick(() => {
        navigator.getUserMedia(
          { audio: true, video: true },
          function (stream) {
            return;
          },
          (e) => {
            console.log(e);
            // this.check = false;
          }
        );
      });
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "FixedAccount")
        vm.$store.commit("UPDATE_FROM_FIXED_ACCOUNT_STATUS", true);
    });
  },

  methods: {
    backAction() {
      this.$router.replace({ name: 'KycProfile', params: {custom: this.isCustomKycRoute} });
    },
    disposeCamera() {
      var options = {
        video: true,
        audio: false,
      };
      navigator.webkitGetUserMedia(
        options,
        function (stream) {
          stream.getTracks().forEach((vid) => vid.stop());
        },
        function (e) {
          console.log("background error : " + e.name);
        }
      );
    },
    async toNext() {
      // this.toggleCamera();
      await this.snap();
    },
    approveImage() {
      setTimeout(() => {
        this.convertToBase64();
      }, 1000);
      this.closeCarmera();
    },
    convertToBase64() {
      var urlCreator = window.URL || window.webkitURL;
      this.pictureInBase64 = urlCreator.createObjectURL(this.picture);
    },

    closeCarmera() {
      setTimeout(() => {
        this.cameraModal = false;
      }, 1000);
    },

    async snap() {
      let file = new File([this.picture], `${Date.now()}`);
      let payload = {
        file,
      };
      this.isLoading = true;
      let res = await this.$store.dispatch("UPLOAD_FILE", payload);
      if (res.status) {
        this.$router.push({ name: "AddDocument", query: {custom: this.isCustomKycRoute} });
      } else {
        eventBus.$emit("trac-alert", {
          message:
            res.message || "Error: Picture failed to upload. Try again...",
        });
      }
      this.isLoading = false;

      this.$store.commit("UPDATE_KYC", res.data);
    },
  },
  mounted() {
    this.payload.businessId = GET_USER_BUSINESS_ID();
    this.payload.reference = GET_USER_BUSINESS_DATA().email;
    this.isCustomKycRoute = this.$route.query.custom;
  },
  beforeDestroy() {},
};
</script>

<style>
.g-gray {
  background: rgba(230, 227, 227, 0.55);
}
.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 500px;
}
.web-camera-container .camera-button {
  margin-bottom: 2rem;
}
.web-camera-container .camera-box .camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  background-color: #fff;
  position: absolute;
}
.web-camera-container .camera-box .camera-shutter.flash {
  opacity: 1;
}
.web-camera-container .camera-shoot {
  margin: 1rem 0;
}
.web-camera-container .camera-shoot button {
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
.web-camera-container .camera-shoot button img {
  height: 35px;
  object-fit: cover;
}
.web-camera-container .camera-loading {
  overflow: hidden;
  height: 100%;
  position: absolute;
  width: 100%;
  min-height: 150px;
  margin: 3rem 0 0 -1.2rem;
}
.web-camera-container .camera-loading ul {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 999999;
  margin: 0;
}
.web-camera-container .camera-loading .loader-circle {
  display: block;
  height: 14px;
  margin: 0 auto;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  transform: translateX(-50%);
  position: absolute;
  width: 100%;
  padding: 0;
}
.web-camera-container .camera-loading .loader-circle li {
  display: block;
  float: left;
  width: 10px;
  height: 10px;
  line-height: 10px;
  padding: 0;
  position: relative;
  margin: 0 0 0 4px;
  background: #999;
  animation: preload 1s infinite;
  top: -50%;
  border-radius: 100%;
}
.web-camera-container .camera-loading .loader-circle li:nth-child(2) {
  animation-delay: 0.2s;
}
.web-camera-container .camera-loading .loader-circle li:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes preload {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
</style>
